// app/javascript/dashboard/api/inbox/historyClosingReason.js
/* global axios */
import ApiClient from '../ApiClient';

class HistoryClosingReasonApi extends ApiClient {
  constructor() {
    super('history_closing_reasons', { accountScoped: true });
  }

  getAll({ startDate = null, endDate = null } = {}) {
    const params = {};

    if (startDate && endDate) {
      params.start_date = startDate;
      params.end_date = endDate;
    }

    return axios.get(this.url, { params });
  }

  getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.put(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new HistoryClosingReasonApi();
